import api from '@/apis'
import { API_PREFIX } from '@/constants'
import type { SealedOrderAvailabilityResponse } from '@/payment/types'

/**
 * 밀봉비닐 1차 주문 가능 여부 — GET /order/api/v2/product-orders/availability.
 *
 * 백엔드 명세 (2026-05-27): `{ data: { isAvailable: boolean } }`.
 * 재고·활성주문·정책 등 백엔드 측 종합 판단 결과를 boolean 으로만 전달.
 * 사유는 응답에 없음 — false 시 화면에서는 통합 "신청 불가" 안내 (재고 소진 화면 재사용).
 */
export const apiGetSealedOrderAvailability = async (): Promise<boolean> => {
  const data = await api.get<SealedOrderAvailabilityResponse>(`${API_PREFIX.ORDER}/product-orders/availability`)
  return data.isAvailable
}
